import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ProcessHero from './components/ProcessHero';
import ProcessOverview from './components/ProcessOverview';
import ProcessSteps from './components/ProcessSteps';
import ProcessFaq from './components/ProcessFaq';
import CtaSection from '@/pages/home/components/CtaSection';

export default function ProcessPage() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <ProcessHero />
        <ProcessOverview />
        <ProcessSteps />
        <ProcessFaq />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
